import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import { createMedia } from './vue/media';
import Gateway from './vue/components/Gateway';
import { loadSentry, captureWarning } from './vue/helpers/sentry';

const script = document.currentScript;
const scriptURL = new URL(script.src);
const locale = scriptURL.searchParams.get('locale') || document.documentElement.lang || 'de';

const i18n = createI18n({
    locale,
    fallbackLocale: 'de',
    messages: {
        de: {
            searchTitle: 'Wohnort oder Kanton',
            searchText: 'Wo suchen Sie Hilfe?',
            specializationsTitle: 'Spezialisierung',
            specializationsText: 'Um welches Thema geht es?',
            offeringsTitle: 'Angebot',
            offeringsText: 'Wie können wir Ihnen helfen?',
            submit: 'Angebote anzeigen',
            place: {
                empty: 'Keine Ergebnisse',
                clear: 'Filter löschen',
                locate: 'Meinen Standort ermitteln',
            },
            view: {
                locateError: 'Ihre Position konnte nicht ermittelt werden.'
            },
            filters: {
                apply: 'anwenden'
            }
        },
        fr: {
            searchTitle: 'Lieu de domicile ou canton',
            searchText: 'Où cherchez-vous de l’aide ?',
            specializationsTitle: 'Spécialisation',
            specializationsText: 'Pour quel thème ?',
            offeringsTitle: 'Offre',
            offeringsText: 'Comment vous aider ?',
            submit: 'Afficher les offres',
            place: {
                empty: 'Aucun résultat',
                clear: 'Effacer le filtre',
                locate: 'Déterminer ma position',
            },
            view: {
                locateError: 'Votre position n’a pas pu être déterminée.'
            },
            filters: {
                apply: 'appliquer'
            }
        },
        it: {
            searchTitle: 'Luogo di domicilio o Cantone',
            searchText: 'Dove cerca aiuto?',
            specializationsTitle: 'Specializzazione',
            specializationsText: 'Per quale tema?',
            offeringsTitle: 'Offerta',
            offeringsText: 'Come possiamo aiutarla?',
            submit: 'Mostrare le offerte',
            place: {
                empty: 'Nessun risultato',
                clear: 'Cancellare il filtro',
                locate: 'Localizzare la mia posizione',
            },
            view: {
                locateError: 'Non è stato possibile determinare la Sua posizione.'
            },
            filters: {
                apply: 'applicare'
            }
        }
    },
    missing: (locale, key) => {
        captureWarning(`i18n :: Key "${ key }" not found for locale "${ locale }"`);
    }
});

(async () => {
    const app = createApp(Gateway);
    app.use(i18n);
    app.use(createMedia());

    app.provide('baseUrl', scriptURL.origin);
    app.provide('locale', locale);

    const container = document.createElement('div');
    container.classList.add('suchtindex-gateway');
    script.parentNode.insertBefore(container, script);
    const shadow = container.attachShadow({ mode: 'open' });
    shadow.appendChild(window.SI_GATEWAY_CSS);

    const root = document.createElement('div');
    shadow.appendChild(root);

    app.mount(root);

    loadSentry(app);
})();
